import { IAuctionInfo } from 'types/auctionTypes'
import { IVehicleInfo } from 'types/vehicleTypes'
import { colorDanger, colorWarning, colorWinning, textColor } from 'common/theme'
import { VehicleStatuses } from 'common/constants'
import { CountDown } from './CountDown'
import { useEffect, useState } from 'react'

interface IProps {
  vehicleInfo: IVehicleInfo
  auctionInfo?: IAuctionInfo
}
export const CountDownWithColor = ({ vehicleInfo, auctionInfo }: IProps) => {
  const [timeLeftInSeconds, setTimeLeftInSeconds] = useState<number>(0)

  // Parse the groundingTimeLeft string (e.g., "0D 14H 33M 26S") into seconds
  const parseGroundingTimeLeft = (timeString: string): number => {
    if (!timeString) return 0

    let seconds = 0
    const daysMatch = timeString.match(/(\d+)D/)
    const hoursMatch = timeString.match(/(\d+)H/)
    const minutesMatch = timeString.match(/(\d+)M/)
    const secondsMatch = timeString.match(/(\d+)S/)

    if (daysMatch) seconds += parseInt(daysMatch[1]) * 24 * 60 * 60
    if (hoursMatch) seconds += parseInt(hoursMatch[1]) * 60 * 60
    if (minutesMatch) seconds += parseInt(minutesMatch[1]) * 60
    if (secondsMatch) seconds += parseInt(secondsMatch[1])

    return seconds
  }

  useEffect(() => {
    // If we have groundingTimeLeft as a string, parse it to seconds
    if (!auctionInfo?.EndDate && vehicleInfo.groundingTimeLeft) {
      const seconds = parseGroundingTimeLeft(vehicleInfo.groundingTimeLeft)
      setTimeLeftInSeconds(seconds)
    }
  }, [vehicleInfo.groundingTimeLeft, auctionInfo?.EndDate])

  const timeRemainingColor = () => {
    if (auctionInfo?.HasPreviousBid && auctionInfo?.IsHighestBidder) return colorWinning
    if (auctionInfo?.HasPreviousBid && !auctionInfo?.IsHighestBidder) return colorDanger
    if (auctionInfo?.IsDirectSale && vehicleInfo?.OfferID === 0) return colorWarning
    return textColor
  }

  // Create a future date based on the current time plus the parsed seconds
  const getEndDate = () => {
    if (auctionInfo?.EndDate) return auctionInfo.EndDate

    if (timeLeftInSeconds > 0) {
      const futureDate = new Date()
      futureDate.setSeconds(futureDate.getSeconds() + timeLeftInSeconds)
      return futureDate
    }

    return null
  }

  return (
    <>
      {vehicleInfo.StatusID !== VehicleStatuses.SoldNotFunded && getEndDate() && (
        <CountDown endDate={getEndDate()} color={timeRemainingColor()} />
      )}
    </>
  )
}
